import React from 'react';
import './CCTVSolutions.css';

import { solutions } from '../../../constants';



const CCTVSolutions = () => {
    return (
        <section className="cctv-solutions">
            {solutions.map((solution) => (
                <div key={solution.id} className="solution-item">
                    <div className='icon'>{solution.icon}</div>
                    <div className="intro">
                        <h3>{solution.title}</h3>
                        <a href={solution.link} className="btn">Learn More</a>
                    </div>
                </div>
            ))}
        </section>
    );
};

export default CCTVSolutions;